var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Styled } from './style';
var AppStoreCategoryCard = /** @class */ (function (_super) {
    __extends(AppStoreCategoryCard, _super);
    function AppStoreCategoryCard(props) {
        return _super.call(this, props) || this;
    }
    AppStoreCategoryCard.prototype.render = function () {
        var _this = this;
        return (React.createElement(Styled, { className: this.props.id },
            React.createElement("div", { onClick: function () { return _this.props.onClick(_this.props.id); }, className: "content", title: this.props.name },
                React.createElement("i", { className: "image" }),
                React.createElement("div", { className: "text" },
                    React.createElement("h3", { className: "title" }, this.props.name),
                    this.props.count &&
                        this.props.count > 1 && (React.createElement("small", { className: "count" },
                        React.createElement(FormattedMessage, { id: "ui_component.apps.collection_of", defaultMessage: "Collection of {count, number} apps", values: { count: this.props.count } })))))));
    };
    return AppStoreCategoryCard;
}(React.Component));
export default AppStoreCategoryCard;
//# sourceMappingURL=index.js.map